import React, {useEffect, useState} from 'react';
import {useWidget} from '../useWidget';

export function ActiveTopBar() {
  const {header} = useWidget();

  const [topBarContent, setTopBarContent] = useState<React.ReactNode>(
    header.getTopBar(),
  );

  useEffect(() => {
    const sub = header.topBarObservable().subscribe(setTopBarContent);
    return () => sub.unsubscribe();
  }, [header]);

  if (topBarContent) {
    return topBarContent;
  }

  return null;
}
